import { initToggleTags, grubScrolling, autoScroll } from './helper'

autoScroll(['category_id'])

initToggleTags({
  wrapClass: 'request-item',
  activeClass: 'request-item--active',
  togglerClass: 'request-item__head',
})

grubScrolling('.requests__tags', {
  left: '.contacts-page__head .slide-controls__btn--left',
  right: '.contacts-page__head .slide-controls__btn--right',
})